module.exports = __webpack_public_path__ + "img/miden.9cdef2dd.svg";